var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22L1.19586 20.1776C1.39952 18.2827 2.09548 16.4741 3.21459 14.9314L3.50218 14.535C4.19115 13.5853 5.06793 12.7873 6.07813 12.1905L6.34841 12.0308C7.49074 11.356 8.79322 11 10.12 11V11C11.4468 11 12.7493 11.356 13.8916 12.0308L14.1619 12.1905C15.1721 12.7873 16.0488 13.5853 16.7378 14.535L17.0254 14.9314C18.1445 16.4741 18.8405 18.2827 19.0441 20.1776L19.24 22",
    stroke: "#456D64",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.187 5.5C14.187 8.06413 12.2907 10 10.1204 10C7.9501 10 6.05371 8.06413 6.05371 5.5C6.05371 2.93587 7.9501 1 10.1204 1C12.2907 1 14.187 2.93587 14.187 5.5Z",
    stroke: "#456D64",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.f2ac2509de241b940bb172ac09c2081e.svg";
export { ForwardRef as ReactComponent };